export default __webpack_public_path__ + "static/media/ohld-261010.1bbe57f6.png";